import React from "react";

const LogoCell = ({ value, logoUrl }) => {
    return <div className="logo">{logoUrl ? <img src={logoUrl} alt={value} width="100" /> : value}</div>;
};

export default LogoCell;
